// @ts-check
import { rateLimitService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { accountUserService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  GET_RATE_LIMITS_BY_USER,
} from './actionTypes';

import {
  SET_RATE_LIMITS_BY_USER,
}
from './mutationTypes';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR
} from '@/store/helpers';

/** @type {import('vuex').ActionTree} */
const actions = {

  /**
   * Get Rate Limits By User
   */
  async [GET_RATE_LIMITS_BY_USER]({ rootState, commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_RATE_LIMITS_BY_USER });
    try {
      let rateLimits = await rateLimitService.getRateLimitsByUser(rootState.currentAccountId);

      if (!rateLimits) {
        rateLimits = [];
      }

      const users = {};

      const accountUsers = await accountUserService.getAccountUsers(rootState.currentAccountId);


      accountUsers.forEach(user => {
        users[user.id] = {"email": user.email, "name": user.name, "role": user.role};
      })

      rateLimits = rateLimits.map(item => {
        const currentUser = users[item.userId] || {}
        const roleInTitleCase = currentUser.role.charAt(0).toUpperCase() + currentUser.role.slice(1).toLowerCase();
        // If the user is not found in the users object, then we create an entry.
        if (!users.hasOwnProperty(item.userId)) {
          const userName = currentUser.name || 'Unknown';
          const userEmail = currentUser.email || 'Unknown';
          const userRole = currentUser.role || 'Unknown';

          return { ...item, "email": userEmail, "name": userName, "role": userRole };
        } else {
          // If the user is found in the users object, then we update the entry.
          return { ...item, "email": currentUser.email, "name": currentUser.name, "role": roleInTitleCase };
        }
      })
      
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_RATE_LIMITS_BY_USER });
      commit(SET_RATE_LIMITS_BY_USER, rateLimits);
    } catch (e) {
      console.log('error', e);
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_RATE_LIMITS_BY_USER, error: e });
    }
  }
};

export default actions;